// @ts-nocheck
import React from 'react';
import lightLogo from '../../assets/images/captureLogoLight.svg';
import darkLogo from '../../assets/images/captureLogoDark.svg';
import lightMark from '../../assets/images/captureMarkLight.svg';
import darkMark from '../../assets/images/captureMarkDark.svg';

const CaptureLogo = ({ className = '', style, alt = 'Capture by Movology', compact = false }) => {
  const light = compact ? lightMark : lightLogo;
  const dark = compact ? darkMark : darkLogo;
  return (
    <span className={`mov-logo ${className}`} style={style}>
      <img src={light} alt={alt} className="mov-logo-light" />
      <img src={dark} alt="" aria-hidden="true" className="mov-logo-dark" />
    </span>
  );
};

export default CaptureLogo;
